import { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Link } from "react-router-dom"
import { toast } from "react-toastify"
import NumberFormat from "react-number-format"

import moment from "moment"

import { Model } from "../../../../models/model"
import { SummaryGeneral } from "./SummaryGeneral"
import { iniUpdateBudget } from "../../../../redux/actions/pptos"
import { parseToNum } from "../../../../helpers/pptosGastos"
import { Autocomplete, createFilterOptions, TextField } from "@mui/material"
import { fetchConTokenFileExcel } from "../../../../helpers/fetch"
import { useCallback } from "react"

import { on } from "../../../../utils/eventBus";
import { Download, Save } from "lucide-react"
import { RowFlows } from "./RowFlows"

const filter = createFilterOptions();

export const FlowSectionGeneral = ({ form, setForm, handleGetInfoItem, tasksList = null, currentTasks = null, handleOpenNewInvoice, handleOpenNewInvoiceSelected, openResumen, setOpenResumen }) => {

    const { listaTiposDocumentos } = useSelector(state => state.general)
    const { listSuppliers } = useSelector(state => state.contacts)

    const dispatch = useDispatch()
    const detailBudget = useSelector(state => state.ppto.detail)

    const {
        id: id_ppto,
        id_cliente,
        separacion_miles,
        separacion_decimales,
        simbolo,
        id_moneda,
        valor_tipo_cambio
    } = useSelector(state => state.ppto.detail)

    const [flowsList, setFlowsList] = useState([])
    const [initialFlowsList, setInitialFlowsList] = useState([])

    const [filterSelected, setFilterSelected] = useState({
        // status: 'pendiente',
        status: '',
        id_proveedor: null,
        total_proveedor: 0
    })

    const [hitosList, setHitosList] = useState(tasksList || [])
    const [invoicesList, setInvoicesList] = useState([])
    const [buysList, setBuysList] = useState([])
    // const [pptoId, setPPtoId] = useState(id_ppto || form?.id_presupuesto)
    const pptoId = id_ppto || form?.id_presupuesto
    const [itemsSelected, setItemsSelected] = useState([])

    const filters = {
        id_ppto: pptoId,
        view: 'list',
        id_responsable: 0,
        estado: '',
        programacion: ''
    }

    const handleGetTasks = useCallback(async () => {

        const filtersx = {
            id_ppto: pptoId,
            view: 'list',
            id_responsable: 0,
            estado: '',
            programacion: ''
        }

        const params = (new URLSearchParams(filtersx)).toString()
        const newTasksList = await Model.getAll({ url: `tasks/?${params}` })
        setHitosList(newTasksList)

    }, [pptoId])

    const iniCargarInvoices = useCallback(async () => {

        const params = {
            url: `invoices/by-pptos/all/${pptoId}`,
        }

        const dataList = await Model.getAll(params)
        const dataListNoFlow = dataList?.invoices?.filter(f => (f.flow_id === null || f.flow_id === ''))
        setInvoicesList(dataListNoFlow || [])
    }, [pptoId])

    const initLoadBuys = useCallback(async () => {

        const filters_ = (new URLSearchParams({ ppto_id: pptoId, origen: 'ventas' })).toString()
        const params = {
            url: `compras/by-pptos/all/?${filters_}`,
        }

        const dataList = await Model.getAll(params)        
        const dataListNoFlow = dataList?.compras?.filter(b => ((b.flow_id === null || b.flow_id === '') && b.estado !== 'anulada'))
        setBuysList(dataListNoFlow)
    }, [pptoId])
    
    const handleGetFlows = useCallback(async () => {

        const filters = {
            id_ppto: pptoId,
            id_item: form.id,
            by_project: true
        }

        const params = (new URLSearchParams(filters)).toString()
        const resultsFlows = await Model.getAll({
            url: `reports/projections/items/?${params}`,
        })

        /*  console.log({ resultsFlows }) */

        setInitialFlowsList(resultsFlows)
        setFlowsList(resultsFlows)

    }, [pptoId, form.id])

    const handleAdd = async (flowType) => {
        const newId = flowsList?.length + 1

        if (!form.id) {
            toast.warning('Falta seleccionar ítem del presupuesto')
            return false

        }

        const newFlow = {
            id: newId,
            porcentaje_flow: 0,
            monto_neto: 0,
            fecha_proyeccion: currentTasks?.fecha_fin ? moment(currentTasks?.fecha_fin).format('YYYY-MM-DD') : moment(new Date()).format('YYYY-MM-DD'),
            id_tarea: currentTasks ? currentTasks?.id : null,
            tipo_flujo: flowType,
            saved: false
        }

        const resultSaveId = await Model.save({
            url: 'reports/projections/items/new/flow',
            dataForm: {
                id_item: form.id,
                id_ppto: pptoId,
                id_contacto: id_cliente,
                flows: [newFlow]
            }
        })

        const newFlowSaved = {
            ...newFlow,
            id: resultSaveId,
            saved: true
        }

        setFlowsList([...flowsList, newFlowSaved])
    }

    const handleChangeNumber = async (values, id) => {
        if (!values.sourceInfo.event) return false

        const totalItem = parseFloat(form.precio_subtotal)
        const newListUpdate = flowsList.map(flo => {
            if (flo.id === id) {

                let newMontoNeto = values.floatValue
                let newPercentFlow = (newMontoNeto / totalItem) * 100

                if (newMontoNeto > totalItem) {
                    newMontoNeto = totalItem
                    newPercentFlow = 100
                }

                const factorImpuesto = (flo.porcentaje_impuesto ? (parseToNum(flo.porcentaje_impuesto) / 100) : 0);
                const totalImpuesto = parseToNum(newMontoNeto) * parseToNum(factorImpuesto)
                const newtotalImpuesto = parseToNum(totalImpuesto, 2, true)

                let newTotal = 0
                if (flo.impuesto_tipo_calculo === 'retencion') {
                    const totalAux = parseToNum(newMontoNeto) - parseToNum(newtotalImpuesto)
                    newTotal = parseToNum(totalAux, 2, true)
                } else {
                    const totalAux = parseToNum(newMontoNeto) + parseToNum(newtotalImpuesto)
                    newTotal = parseToNum(totalAux, 2, true)
                }

                return {
                    ...flo,
                    monto_neto: newMontoNeto,
                    porcentaje_flow: newPercentFlow,
                    total: newTotal
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)
        await calBalances(newListUpdate)

    }

    const handleChangeHito = async ({ target }, id) => {
        const hitoId = target.value
        const infoHito = hitosList.find(hi => hi.id === hitoId)

        const newListUpdate = flowsList.map(flo => {
            const fecha = infoHito ? moment(infoHito.fecha_fin).format('YYYY-MM-DD') : flo.fecha_proyeccion

            if (flo.id === id) {
                return {
                    ...flo,
                    [target.name]: hitoId,
                    fecha_proyeccion: fecha
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)

    }

    const calBalances = async (flowsUpdate, returnValue = false) => {
        let sumTotalIngresos = 0
        let sumTotalEgresos = 0

        let sumFacturado = 0
        let sumCobrado = 0
        let sumPorCobrar = 0

        let sumGastado = 0
        let sumPagado = 0
        let sumPorPagar = 0

        for (let x = 0; x < flowsUpdate.length; x++) {
            if (flowsUpdate[x].tipo_flujo === 'ingreso') {
                sumTotalIngresos = sumTotalIngresos + parseFloat(flowsUpdate[x].monto_neto)

                if (flowsUpdate[x].info_invoice?.id) {
                    sumFacturado = sumFacturado + parseFloat(flowsUpdate[x].info_invoice?.monto_base)
                    sumCobrado = sumCobrado + parseFloat(flowsUpdate[x].info_invoice?.total_cobrado)
                    sumPorCobrar = sumPorCobrar + parseFloat(flowsUpdate[x].info_invoice?.total_por_cobrar)
                }

            } else {
                sumTotalEgresos = sumTotalEgresos + parseFloat(flowsUpdate[x].monto_neto)

                if (flowsUpdate[x].info_invoice?.id) {
                    sumGastado = sumGastado + parseFloat(flowsUpdate[x].info_invoice?.monto_base)
                    sumPagado = sumPagado + parseFloat(flowsUpdate[x].info_invoice?.total_pagado)
                    sumPorPagar = sumPorPagar + parseFloat(flowsUpdate[x].info_invoice?.total_por_pagar)
                }
            }
        }

        const saldoPorProyectar = parseFloat(form.precio_subtotal) - parseFloat(sumTotalIngresos || 0)

        const newValues = {
            total_proyectado: sumTotalIngresos,
            saldo_por_proyectar: saldoPorProyectar > 0 ? saldoPorProyectar : 0,
            total_proyectado_egresos: sumTotalEgresos,
            saldo_por_proyectar_egresos: parseFloat(form.costo_subtotal) - parseFloat(sumTotalEgresos || 0),

            total_facturado: sumFacturado,
            total_por_facturar: sumTotalIngresos - sumFacturado,
            total_cobrado: sumCobrado,
            total_por_cobrar: sumPorCobrar,

            total_gastado: sumGastado,
            total_por_gastar: sumTotalEgresos - sumGastado,
            total_pagado: sumPagado,
            total_por_pagar: sumPorPagar
        }

        setForm({
            ...form,
            ...newValues
        })

        if (returnValue) {
            return newValues
        }

    }

    const handleRemove = async (id) => {
        const newListUpdate = flowsList.filter(flo => flo.id !== id)
        setFlowsList(newListUpdate)

        const returnValue = true
        const totalValues = await calBalances(newListUpdate, returnValue)

        await Model.delete({
            url: `reports/projections/delete/flow/${id}`,
            dataForm: {
                id_item: form.id,
                id_ppto: pptoId,
                id_contacto: id_cliente,
                ...totalValues
            },
            resultData: true
        })

        dispatch(iniUpdateBudget(detailBudget, pptoId));
        //dispatch(budgetsUpdateProjections(flowListUpdated))

    }

    const handleSave = async () => {
        // console.log('--antes save--', flowsList)

        await Model.update({
            url: 'reports/projections/items/flow/0',
            dataForm: {
                id_item: form.id,
                id_ppto: pptoId,
                total_item_ppto: form?.precio_subtotal,
                ...form,
                flows: flowsList
            }
        })

        setInitialFlowsList(flowsList)

        if (form.id) {
            await handleGetInfoItem(form.id)
        }

        handleGetFlows()

    }

    const handleSaveSelected = async (formUpdate, flowsListUpdated) => {

        await Model.update({
            url: 'reports/projections/items/flow/0',
            dataForm: {
                ...formUpdate,
                id_item: formUpdate.id,
                id_ppto: pptoId,
                id_contacto: id_cliente,
                total_item_ppto: formUpdate?.precio_subtotal,
                flows: flowsListUpdated
            }
        })

        await handleGetInfoItem(formUpdate.id)
        handleGetFlows()

    }

    const handleChangeSelectInvoice = async ({ target }, flow) => {
        const { value: invoiceId } = target

        if (invoiceId !== '') {
            const invoiceInfo = invoicesList.find(f => f.id === invoiceId)
            console.log({ invoiceInfo })

            const totalItem = parseFloat(form.precio_subtotal)
            const montoBaseInvoice = parseFloat(invoiceInfo?.monto_base)
            const porcentajeFlow = (montoBaseInvoice / totalItem) * 100
            const montoNeto = montoBaseInvoice
            const totalFactura = parseFloat(invoiceInfo?.total_factura || 0)
            const impuestoPorcentaje = parseFloat(invoiceInfo?.impuesto_porcentaje || 0)

            const newListUpdate = flowsList.map(flo => {
                if (flo.id === flow.id) {
                    return {
                        ...flo,
                        fecha_proyeccion: invoiceInfo.fecha_emision,
                        porcentaje_flow: porcentajeFlow,
                        invoice_edit: true,
                        invoice_buy_id: invoiceId,
                        info_invoice: invoiceInfo,
                        id_doc: invoiceInfo?.id_tipo_documento || null,
                        monto_neto: montoNeto,
                        porcentaje_impuesto: impuestoPorcentaje,
                        total: totalFactura
                    }
                }

                return flo
            })

            setFlowsList(newListUpdate)
            const totalesUpdated = await calBalances(newListUpdate, true)

            const newForm = {
                ...form,
                ...totalesUpdated
            }

            await handleSaveSelected(newForm, newListUpdate)
            iniCargarInvoices()

        }
    }

    const handleChangeSelectBuy = async ({ target }, flow) => {
        const { value: buyId } = target

        if (buyId !== '') {
            const buyInfo = buysList.find(b => b.id === buyId)
            // console.log({ buyInfo })

            const totalCostoItem = parseFloat(form.costo_subtotal)
            let montoBaseBuy = parseFloat(buyInfo?.monto_base || 0)
            let totalCompra = parseFloat(buyInfo?.total_compra || 0)

            let newIdMonedaFlujo = buyInfo?.id_moneda
            let newValorCambioFlujo = parseFloat(buyInfo?.valor_tipo_cambio)

            // si es proyecto en usd y gasto en soles
            if (parseInt(detailBudget.id_moneda) === 4 && parseInt(buyInfo?.id_moneda) !== 4) {

                // se convierte a usd
                newIdMonedaFlujo = detailBudget?.id_moneda
                newValorCambioFlujo = parseFloat(detailBudget?.valor_tipo_cambio || 1)
                montoBaseBuy = montoBaseBuy / newValorCambioFlujo
                totalCompra = totalCompra / newValorCambioFlujo

            } else if (parseInt(detailBudget.id_moneda) === 3 && parseInt(buyInfo?.id_moneda) === 4) {

                // si es proyecto en soles y gasto en usd
                // se convierte a soles
                newIdMonedaFlujo = detailBudget?.id_moneda
                newValorCambioFlujo = parseFloat(buyInfo?.valor_tipo_cambio || 1)
                montoBaseBuy = montoBaseBuy * newValorCambioFlujo
                totalCompra = totalCompra * newValorCambioFlujo

            }

            //montoBaseBuy = parseFloat(buyInfo?.monto_base)
            const porcentajeFlow = (montoBaseBuy / totalCostoItem) * 100
            const montoNeto = montoBaseBuy
            //const totalCompra = parseFloat(buyInfo?.total_compra || 0)

            const newListUpdate = flowsList.map(flo => {
                if (flo.id === flow.id) {
                    return {
                        ...flo,
                        fecha_proyeccion: buyInfo.fecha_emision,
                        porcentaje_flow: porcentajeFlow,
                        monto_neto: montoNeto,
                        invoice_edit: true,
                        invoice_buy_id: buyId,
                        info_invoice: buyInfo,
                        id_proveedor: buyInfo.id_proveedor,
                        id_doc: buyInfo.id_tipo_documento,
                        estado: buyInfo?.estado === 'pagada' ? 'pagada' : 'pendiente',
                        porcentaje_impuesto: parseFloat(buyInfo.impuesto_porcentaje),
                        total: totalCompra,
                        id_moneda: newIdMonedaFlujo,
                        valor_tipo_cambio: newValorCambioFlujo
                    }
                }

                return flo
            })

            setFlowsList(newListUpdate)
            const totalesUpdated = await calBalances(newListUpdate, true)

            const newForm = {
                ...form,
                ...totalesUpdated
            }

            await handleSaveSelected(newForm, newListUpdate)
            initLoadBuys()

        }
    }

    const handleRemoveInvoice = async (type, flow) => {
        const invoiceId = flow?.info_invoice.id

        const newListUpdate = flowsList.map(flo => {
            if (flo.id === flow.id) {
                return {
                    ...flo,
                    info_invoice: null
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)
        const totalesUpdated = await calBalances(newListUpdate, true)

        await Model.update({
            url: `flows/remove/info-doc/${invoiceId}`,
            dataForm: {
                id: invoiceId,
                flow_id: flow.id,
                type,
                id_item: form.id,
                id_ppto: pptoId,
                ...totalesUpdated
            }
        })

        if (type === 'ingreso') {
            iniCargarInvoices()
        } else {
            initLoadBuys()
        }

        handleGetFlows()

    }

    const handleChangeDoc = (e, id) => {
        const { value: newIdDoc } = e.target

        const newList = flowsList.map(it => {
            if (it.id === id) {

                const foundImpuesto = listaTiposDocumentos?.find(doc => parseInt(doc.id) === parseInt(newIdDoc))
                const porcentaje = foundImpuesto.impuestos[0]?.porcentaje_impuesto
                const newPorcentajeImpuesto = parseFloat(porcentaje)
                const impuesto_tipo_calculo = foundImpuesto.impuestos[0]?.tipo_calculo || 'directo'

                const factorImpuesto = (newPorcentajeImpuesto ? (parseToNum(newPorcentajeImpuesto) / 100) : 0);
                const totalImpuesto = parseToNum(it.monto_neto) * parseToNum(factorImpuesto)
                const newtotalImpuesto = parseToNum(totalImpuesto, 2, true)

                let newTotal = 0
                if (impuesto_tipo_calculo === 'retencion') {
                    const totalAPagar = parseToNum(it.monto_neto) - parseToNum(newtotalImpuesto)
                    newTotal = parseToNum(totalAPagar, 2, true)
                } else {
                    const totalAPagar = parseToNum(it.monto_neto) + parseToNum(newtotalImpuesto)
                    newTotal = parseToNum(totalAPagar, 2, true)
                }

                return {
                    ...it,
                    id_doc: newIdDoc,
                    impuesto_tipo_calculo: impuesto_tipo_calculo,
                    porcentaje_impuesto: newPorcentajeImpuesto,
                    total: newTotal
                }
            }

            return it

        })

        setFlowsList(newList)

    }

    const handleChangeDate = async (newValue, id) => {
        const newDate = newValue.target.value

        const newListUpdate = flowsList.map(flo => {
            if (flo.id === id) {
                return {
                    ...flo,
                    fecha_proyeccion: newDate
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)

    }

    const handleChangeRef = async (newRef, id) => {

        const newListUpdate = flowsList.map(flo => {
            if (flo.id === id) {
                return {
                    ...flo,
                    referencia: newRef
                }
            }

            return flo
        })

        setFlowsList(newListUpdate)

    }

    const handleItemSelected = (e, item) => {
        const { checked } = e.target

        if (checked) {

            setItemsSelected([
                ...itemsSelected,
                item
            ])

        } else {

            const listUpdated = itemsSelected.filter(it => it.id !== item.id)
            setItemsSelected(listUpdated)

        }

    }

    const handleChangeSupplier = (e, newValue, item) => {

        const newList = flowsList.map(it => {
            if (it.id === item.id) {
                return {
                    ...it,
                    id_contacto: newValue.id,
                }
            }

            return it

        })

        setFlowsList(newList)

    }

    const handleFilters = (newValue, target) => {

        let newFilters = {
            ...filterSelected,
            total_proveedor: 0,
            [target]: newValue
        }

        let newListFiltered = initialFlowsList

        if (newFilters.status !== '') {
            newListFiltered = newListFiltered.filter(it => it.estado === newFilters.status)
        }
        // else {
        //     newListFiltered = newListFiltered
        // }

        if (newFilters.id_proveedor !== '' && newFilters.id_proveedor !== null) {
            newListFiltered = newListFiltered.filter(it => it.id_contacto === newFilters.id_proveedor)

            let newTotal = 0
            let newTotalUsd = 0
            for (let x = 0; x < newListFiltered.length; x++) {

                if (parseInt(newListFiltered[x].id_moneda) === 4) {
                    const valorCambio = parseFloat(newListFiltered[x].valor_tipo_cambio) || 1
                    newTotal = newTotal + (parseFloat(newListFiltered[x].total) * valorCambio)
                    newTotalUsd = newTotalUsd + parseFloat(newListFiltered[x].total)
                } else if (parseInt(newListFiltered[x].id_moneda) === 3) {
                    newTotal = newTotal + parseFloat(newListFiltered[x].total)
                }

            }

            newFilters = {
                ...newFilters,
                total_proveedor: newTotal,
                total_proveedor_usd: newTotalUsd
            }

        }
        // else {
        //     newListFiltered = newListFiltered
        // }

        setFilterSelected(newFilters)
        setFlowsList(newListFiltered)

    }

    const initExport = async () => {

        const filtersAux = {
            id_ppto: pptoId,
            id_item: form.id,
            by_project: true
        }

        const params = (new URLSearchParams(filtersAux)).toString()
        const fileName = `flujos_${new Date()}_`
        // const resp = await fetchConTokenFileExcel(`reports/projections/items/flow/export/?${params}`, {}, 'GET', fileName)
        await fetchConTokenFileExcel(`reports/projections/items/flow/export/?${params}`, {}, 'GET', fileName)
    }

    useEffect(() => {
        if (pptoId) {
            handleGetFlows()
        }
    }, [pptoId, handleGetFlows])

    useEffect(() => {
        handleGetTasks()
    }, [handleGetTasks])

    useEffect(() => {
        iniCargarInvoices()
    }, [iniCargarInvoices])

    useEffect(() => {
        initLoadBuys()
    }, [initLoadBuys])

    useEffect(() => {

        const unsub = on("flows_updated", handleGetFlows);
        return unsub;

    }, [handleGetFlows]);

    return (
        <div>

            {openResumen && (
                <SummaryGeneral
                    form={form}
                    handleAdd={handleAdd}
                />
            )}

            <div className='grid grid-cols-2 items-center mt-2 border border-1 sticky top-0 left-0 bg-white z-30 p-2'>
                <div className="flex items-center">
                    <div className='p-box-menu-tab-new'>
                        <Link to="" className={filterSelected.status === '' ? 'selected' : ''} onClick={() => handleFilters('', 'status')}>Todos <span style={{ fontSize: '12px' }}>({initialFlowsList?.length || 0})</span></Link>
                        <Link to="" className={`ms-2 ${filterSelected.status === 'pendiente' ? 'selected' : ''}`} onClick={() => handleFilters('pendiente', 'status')}>Pendientes <span style={{ fontSize: '12px' }}>({(initialFlowsList?.filter(p => p.estado === 'pendiente')).length || 0})</span></Link>
                        <Link to="" className={`ms-2 ${filterSelected.status === 'pagada' ? 'selected' : ''}`} onClick={() => handleFilters('pagada', 'status')}>Pagados <span style={{ fontSize: '12px' }}>({(initialFlowsList?.filter(p => p.estado === 'pagada')).length || 0})</span></Link>
                    </div>
                    <div className="p-text-autocomplete ms-3 w-52">
                        <Autocomplete
                            value={listSuppliers?.find((it) => (parseInt(it.id) === parseInt(filterSelected.id_proveedor))) || null}
                            onChange={(e, newValue) => handleFilters((newValue?.id || null), 'id_proveedor')}
                            filterOptions={(options, params) => {
                                const filtered = filter(options, params);
                                return filtered;
                            }}
                            id="auto-complete"
                            autoComplete
                            includeInputInList
                            fullWidth
                            options={listSuppliers}
                            getOptionLabel={(option) => {
                                if (typeof option === 'string') {
                                    return option;
                                }

                                return option.nombre
                            }}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    label="Filtro por proveedor"
                                /*  variant="standard" */
                                />
                            )}
                        />

                        {filterSelected.total_proveedor > 0 ?
                            <>
                                <span>Total:</span>
                                <NumberFormat
                                    className="ms-2"
                                    style={{ color: '#78717A', fontSize: '12px', fontWeight: 'bold' }}
                                    displayType={'text'}
                                    value={filterSelected.total_proveedor || 0}
                                    /* thousandSeparator={separacion_miles}
                                    decimalSeparator={separacion_decimales}
                                    prefix={`${simbolo} `} */
                                    thousandSeparator={','}
                                    decimalSeparator={'.'}
                                    prefix={`S/ `}
                                    decimalScale={2}
                                    fixedDecimalScale={2}
                                />
                            </>
                            : ''
                        }

                    </div>
                </div>
                <div className="flex justify-end items-center">
                    {flowsList?.length > 0 ?
                        <div>
                            <button className='flex btn border items-center text-sm rounded-md' onClick={() => initExport(filters)}>
                                <Download className="w-4 h-4" />
                                <span className="ms-2">Exportar</span>
                            </button>
                        </div> : ''
                    }
                    <button
                        className='flex btn border items-center text-sm ms-2 rounded-md bg-[--primary-color] text-white'
                        onClick={handleSave}
                    >
                        <Save className="w-4 h-4" />
                        <span className="ms-2">Guardar cambios</span>
                    </button>
                </div>
            </div>

            {
                flowsList?.length === 0 ?
                    <h5 className="text-base text-center p-4 mt-3 mb-2">No hay flujos proyectados.</h5>
                    :
                    <table className="table p-table-global">
                        <thead className='p-thead-global'>
                            <tr className="text-center p-tr-titles-global">
                                <th className='text-start sticky top-20 left-0 z-30'>Ítem</th>
                                <th className='title text-end sticky top-20 bg-white z-20'>Monto neto</th>
                                <th className='title text-end sticky top-20 bg-white z-20'>Fecha proyectada</th>
                                <th className='title text-center sticky top-20 bg-white z-20'>Tarea</th>
                                <th className='title text-center sticky top-20 bg-white z-20'>Proveedor</th>
                                <th className='title text-start sticky top-20 bg-white z-20'>Estado</th>
                                {/*  <th colSpan={3} className='title text-end sticky top-20 z-20 hidden'>
                                    {itemsSelected.length > 0 ?
                                        <Link
                                            to=""
                                            onClick={() => handleOpenNewInvoiceSelected(itemsSelected, 'egreso')}
                                            className="p-mini-link"
                                            style={{ fontSize: '12px', textTransform: 'capitalize', color: 'red' }}
                                        >
                                            + Crear gasto ({itemsSelected.length})
                                        </Link> : ''
                                    }
                                </th> */}
                            </tr>
                        </thead>
                        <tbody>
                            {flowsList?.map(flo => (
                                <RowFlows
                                    key={flo.id}
                                    flo={flo}
                                    handleChangeNumber={handleChangeNumber}
                                    handleChangeDate={handleChangeDate}
                                    handleChangeHito={handleChangeHito}
                                    handleChangeSupplier={handleChangeSupplier}
                                    listSuppliers={listSuppliers}
                                    handleChangeDoc={handleChangeDoc}
                                    listaTiposDocumentos={listaTiposDocumentos}
                                    valor_tipo_cambio={valor_tipo_cambio}
                                    simbolo={simbolo}
                                    separacion_miles={separacion_miles}
                                    separacion_decimales={separacion_decimales}
                                    setOpenResumen={setOpenResumen}
                                    openResumen={openResumen}
                                    id_moneda={id_moneda}
                                    hitosList={hitosList}
                                    handleRemoveInvoice={handleRemoveInvoice}
                                    handleOpenNewInvoice={handleOpenNewInvoice}
                                    handleChangeSelectInvoice={handleChangeSelectInvoice}
                                    invoicesList={invoicesList}
                                    handleChangeSelectBuy={handleChangeSelectBuy}
                                    buysList={buysList}
                                    handleRemove={handleRemove}
                                    handleItemSelected={handleItemSelected}
                                    handleChangeRef={handleChangeRef}
                                />
                            ))}
                        </tbody>
                    </table>
            }


        </div >
    )
}
